import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Box, Tabs, Tab, Card, CardContent, CardActionArea } from '@mui/material';
import SideMenu from '../components/SideMenu';
import TopMenu from '../components/TopMenu';
import { DataGrid } from '@mui/x-data-grid';
import { PieChart, Pie, Legend } from "recharts";
import { pink, blue, teal, yellow, orange } from '@mui/material/colors';

const dataGraph = [
  { name: "Group A", value: 400, fill: "#0088FE" },
  { name: "Group B", value: 300, fill: "#00C49F" },
  { name: "Group C", value: 300, fill: "#FFBB28" },
  { name: "Group D", value: 200, fill: "#FF8042" }
];

const renderColorfulLegendText = (value, entry) => {
  return (
    <span style={{ color: "#596579", fontWeight: 500, padding: "10px" }}>
      {value}
    </span>
  );
};

function Dashboard() {
  const { id } = useParams();

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Top menu */}
      <TopMenu />
      {/* Side menu */}
      <SideMenu />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
          marginTop: '64px',
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={"1"} onChange={() => {}} aria-label="" centered>
            <Tab label="Seller 1" value="1" />
            <Tab label="Seller 2" value="2" />
            <Tab label="Seller 3" value="3" />
          </Tabs>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }} style={{marginTop: 40}}>
          {/* Example table */}
          <Box sx={{ width: '50%' }}>
            <Card sx={{ p: 3, boxShadow: 1 }}>
              <CardContent>
                <Typography variant='h6' color={blue[900]}>
                  Sales by Distribution Channel
                </Typography>
                
                <div style={{ height: 400, width: '100%', marginTop: 15 }}>
                  <DataGrid
                    rows={[
                      { id: 1, name: 'John', age: 35 },
                      { id: 2, name: 'Jane', age: 28 },
                      { id: 3, name: 'Mike', age: 42 },
                    ]}
                    columns={[
                      { field: 'id', headerName: 'ID', width: 90 },
                      { field: 'name', headerName: 'Name', width: 150 },
                      { field: 'age', headerName: 'Age', width: 110 },
                    ]}
                    pageSize={5}
                  />
                </div>

                <Box sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                  <PieChart width={600} height={400} onMouseEnter={() => {}}>
                    <Legend
                      height={36}
                      iconType="circle"
                      layout="vertical"
                      verticalAlign="middle"
                      iconSize={10}
                      padding={5}
                      formatter={renderColorfulLegendText}
                    />
                    <Pie
                      data={dataGraph}
                      cx={120}
                      cy={200}
                      innerRadius={60}
                      outerRadius={80}
                      fill="#8884d8"
                      paddingAngle={0}
                      dataKey="value"
                    >
                    </Pie>
                  </PieChart>
                </Box>
              </CardContent>
            </Card>
          </Box>

          {/* Example chart */}
          <Box sx={{ width: '50%' }}>
            <Card sx={{ p: 3, boxShadow: 1 }}>
              <CardContent>
                <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                  <Typography variant='h6' color={blue[900]}>
                    Past Due Invoices
                  </Typography>

                  <Typography variant='h6' color={pink[500]}>
                    Total: $ 33,168.65
                  </Typography>
                </Box>

                <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 5, marginBottom: 5}}>
                  <Card style={{width: '30%', backgroundColor: teal[100]}}>
                    <CardActionArea onClick={() => {}} sx={{height: '100%'}}>
                      <CardContent sx={{ height: '100%', textAlign: 'center' }}>
                        <Typography variant="h6" component="div">
                          0 - 14 Days
                        </Typography>
                        <Typography variant="body2" color={teal[900]}>
                          7 / $ 14,151.10
                        </Typography>
                        <Typography variant="body2" style={{marginTop: 2}}>
                          <b>42.66 %</b>
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>

                  <Card style={{width: '30%'}}>
                    <CardActionArea onClick={() => {}} sx={{height: '100%', backgroundColor: yellow[100]}}>
                      <CardContent sx={{ height: '100%', textAlign: 'center' }}>
                        <Typography variant="h6" component="div">
                          15 - 29 Days
                        </Typography>
                        <Typography variant="body2" color={yellow[800]}>
                          2 / $ 0.00
                        </Typography>
                        <Typography variant="body2" style={{marginTop: 2}}>
                          <b>42.66 %</b>
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>

                  <Card style={{width: '30%'}}>
                    <CardActionArea onClick={() => {}} sx={{height: '100%', backgroundColor: orange[100]}}>
                      <CardContent sx={{ height: '100%', textAlign: 'center' }}>
                        <Typography variant="h6" component="div">
                          + 30 Days
                        </Typography>
                        <Typography variant="body2" color={orange[900]}>
                          4 / $ 19,017.55
                        </Typography>
                        <Typography variant="body2" style={{marginTop: 2}}>
                          <b>42.66 %</b>
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Box>
                
                <div style={{ height: 400, width: '100%' }}>
                  <DataGrid
                    rows={[
                      { id: 1, name: 'John', age: 35 },
                      { id: 2, name: 'Jane', age: 28 },
                      { id: 3, name: 'Mike', age: 42 },
                    ]}
                    columns={[
                      { field: 'id', headerName: 'ID', width: 90 },
                      { field: 'name', headerName: 'Name', width: 150 },
                      { field: 'age', headerName: 'Age', width: 110 },
                    ]}
                    pageSize={5}
                  />
                </div>
              </CardContent>
            </Card>
          </Box>
        </Box>
      </Box>

    </Box>
  );
}

export default Dashboard;
